import type { RouteObject } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { FULL_WIDTH_PAGE } from '@/shared/layouts/pageLayout';
import { UserCreate } from '../pages/UserCreate';
import { UserDetail } from '../pages/UserDetail';
import { UserEdit } from '../pages/UserEdit';
import { UserList } from '../pages/UserList';

export const usersRoutes: RouteObject[] = [
  {
    path: 'admin/users',
    children: [
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'user', action: 'browse' }]} />,
        children: [
          { index: true, element: <UserList /> },
        ],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'user', action: 'add' }]} />,
        children: [
          { path: 'new', element: <UserCreate /> },
        ],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'user', action: 'read' }]} />,
        children: [
          { path: ':id', element: <UserDetail />, handle: FULL_WIDTH_PAGE },
        ],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'user', action: 'edit' }]} />,
        children: [
          { path: ':id/edit', element: <UserEdit /> },
        ],
      },
    ],
  },
];
